import { epgDatesModel, toTimestamp } from '$/epg/dates'
import { A, flow } from '@mobily/ts-belt'
import { createEvent, createStore, sample } from 'effector'
import { selectEpgDateModel } from '~/features/epg/dates/select'
import { type EpgDateExStamped } from './index.h'
import { translateDate } from './l10n'
import { toStamped } from './lib'

// generate dates list
export const init = createEvent()

// reset widget on epg page left
export const left = createEvent()

/* TODO: check */
// reset widget on sign out
export const reset = createEvent()

// select date
export const select = selectEpgDateModel.setActive

// dates list
export const $list = createStore<EpgDateExStamped[]>([])

// init dates entity
sample({
  clock: init,
  target: epgDatesModel.init,
})

// select initially active date
sample({
  clock: init,
  target: selectEpgDateModel.autoSetActive,
})

// update dates list with respect to initially selected date
sample({
  clock: [init, selectEpgDateModel.$initial, epgDatesModel.$week],
  source: {
    initial: selectEpgDateModel.$initial,
    week: epgDatesModel.$week,
  },
  fn: ({ initial, week }) => {
    let list = week
    if (initial != null) {
      list = A.append(list, initial)
    }
    list = A.sortBy(A.uniqBy(list, toTimestamp), toTimestamp)
    return A.map(list, flow(translateDate, toStamped))
  },
  target: $list,
})

//
// left and reset logic
//

// do nothing
// dates for different users are the same, so,
// no need to reset them on left and/or reset
